export const HEADER_HEIGHT = 42;
export const HEADER_WIDTH = 40;
